/**
 * Produtos do mapa de aplicação: a paleta com que cada marcação é feita.
 *
 * A clínica edita a sua lista (company_application_products). Enquanto não
 * gravou nenhuma, vale esta lista padrão, com `id` null: as marcações feitas
 * com ela guardam nome, unidade e cor e ficam com `productId` null.
 */

export const DEFAULT_PRODUCTS = Object.freeze([
  { id: null, name: 'Toxina botulínica', unit: 'UI', color: '#7C5CFF', defaultQuantity: 4 },
  { id: null, name: 'Ácido hialurônico', unit: 'ml', color: '#FF6B9A', defaultQuantity: 0.5 },
  { id: null, name: 'Bioestimulador', unit: 'ml', color: '#2DBE8C', defaultQuantity: 1 },
  { id: null, name: 'Skinbooster', unit: 'ml', color: '#3BA7F5', defaultQuantity: 0.5 },
  { id: null, name: 'Fios de PDO', unit: 'un', color: '#F5A623', defaultQuantity: 1 },
]);

export const NEW_PRODUCT_COLORS = Object.freeze(['#5A80FB', '#E04F5F', '#1FB5AD', '#B56CF0', '#F28C28', '#4C9A2A']);

export const MAX_PRODUCTS = 30;

/** Lista da clínica quando existe; senão a padrão. */
export function resolveProducts(list) {
  return Array.isArray(list) && list.length > 0
    ? list.map((item) => ({ ...item, defaultQuantity: Number(item.defaultQuantity) }))
    : [...DEFAULT_PRODUCTS];
}

/** Cor sugerida para um produto novo: a primeira ainda não usada na lista. */
export function nextProductColor(products) {
  const used = new Set(products.map((item) => String(item.color || '').toUpperCase()));
  return NEW_PRODUCT_COLORS.find((color) => !used.has(color)) || NEW_PRODUCT_COLORS[products.length % NEW_PRODUCT_COLORS.length];
}
